import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const I18N_PREFIX = 'knowledgeContentUI.chooseTemplate.confirmChangeTemplateModal';
const ConfirmChangeTemplateModal = ({
  onConfirm,
  onReject
}) => {
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    "data-test-id": "change-template-confirm-modal",
    confirmLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${I18N_PREFIX}.confirmButtonLabel`
    }),
    confirmUse: "danger",
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${I18N_PREFIX}.header`
    }),
    size: "auto",
    use: "danger",
    onConfirm: onConfirm,
    onReject: onReject,
    rejectLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${I18N_PREFIX}.rejectButtonLabel`
    })
  });
};
ConfirmChangeTemplateModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired
};
export default ConfirmChangeTemplateModal;